export const SET_HEADER_SECTIONS = "SET_HEADER_SECTIONS";
export const SET_PDP_SECTIONS = "SET_PDP_SECTIONS";
export const SET_PLP_SECTIONS = "SET_PLP_SECTIONS";
export const SET_CART_SECTIONS = "SET_CART_SECTIONS";
export const SET_CHECKOUT_SECTIONS = "SET_CHECKOUT_SECTIONS";
export const SET_ORDER_SUCCESS_SECTIONS = "SET_ORDER_SUCCESS_SECTIONS";
